import React, { ReactNode } from "react"
import { DashboardLayout } from "sharedTypes"
import { useSaveDashboardLayout } from "queries/events"
import CustomizableGrid from "./CustomizableGrid"
import { BlockId } from "../layout"

type Props = {
  eventId: string
  layout?: DashboardLayout | Record<string, never>
  canCustomize: boolean
  blocks: Partial<Record<BlockId, ReactNode>>
  onCustomizingChange: (customizing: boolean) => void
}

const EventDetails = ({
  eventId, layout, canCustomize, blocks, onCustomizingChange,
}: Props) => {
  const saveLayout = useSaveDashboardLayout(eventId)

  return (
    // A fresh grid per event: an open Customize doesn't carry over.
    <CustomizableGrid
      key={eventId}
      blocks={blocks}
      saved={layout}
      canCustomize={canCustomize}
      onSave={saveLayout}
      onCustomizingChange={onCustomizingChange}
    />
  )
}

export default EventDetails
